import { twMerge } from "tailwind-merge";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  wrapperClassName?: string;
  label?: string;
  floatingLabel?: boolean;
}

export function Input({
  label,
  wrapperClassName,
  className,
  floatingLabel = true,
  onKeyDown,
  ...inputProps
}: InputProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.currentTarget.blur();
    }
    onKeyDown?.(e);
  };

  return (
    <div className={twMerge("relative w-full", wrapperClassName)}>
      <input
        type="text"
        id="floating_filled"
        className={twMerge(
          "block rounded-lg px-2.5 pb-2.5 pt-5 w-full text-sm bg-[var(--gray-a1)] border-2 border-[var(--gray-a7)] appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer",
          className
        )}
        placeholder=" "
        onKeyDown={handleKeyDown}
        {...inputProps}
      />
      <label
        htmlFor={inputProps.id || "floating_filled"}
        className={twMerge(
          "absolute text-sm text-[var(--gray-a11)] duration-300 transform origin-[0] left-2.5",
          floatingLabel
            ? "peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-[10px] -translate-y-[10px] scale-75 top-[10px] z-10 peer-focus:text-[var(--accent-a11)] peer-focus:dark:text-[var(--accent-a11)]"
            : "top-0 z-10 scale-75"
        )}
      >
        {label}
      </label>
    </div>
  );
}

export default Input;
